
import { defineComponent, ref } from 'vue';

export default defineComponent({
  emits: ['hide'],
  props: {
    hideBottomDecoration: { type: Boolean, default: false },
    hideTopDecoration: { type: Boolean, default: false },
    desktopPopUpPosition: {
      type: Object,
      default: () => ({
        x: 0,
        y: 0,
      }),
    },
  },
  setup(props, { emit }) {
    const mouseHeight = ref(0);

    return {
      emit,
      mouseHeight,
    };
  },
});
